import { render } from "./ActiveProjectDetails.vue?vue&type=template&id=c9a766a0&scoped=true"
import script from "./ActiveProjectDetails.vue?vue&type=script&lang=js"
export * from "./ActiveProjectDetails.vue?vue&type=script&lang=js"

import "./ActiveProjectDetails.vue?vue&type=style&index=0&id=c9a766a0&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9a766a0"]])

export default __exports__